// 适配crm-core的方法

import moment from 'moment/moment';

// 将FS里面的方法拷贝出来
const CONST = {
  NUM_TIME_MIN: -9223372036854776000, // 时间类型的最小值
  NUM_TIME_DEFAULT: 946656000000, // 时间默认值
  NUM_TIME_DEFAULT2: -62135596800000, // 时间默认值
  TEXT_DEFAULT: '--',
  TEXT_HIDE: '*****',
};

export const getFileExtText = fileName => {
  const extIndex = fileName.lastIndexOf('.');
  let extText;
  if (extIndex === -1) {
    extText = '';
  } else {
    extText = fileName.slice(extIndex + 1);
  }
  return extText;
};

export const getFileType = (fileName, fullTest, moreType) => {
  let fileType = 'common';
  fileName = fileName.toLowerCase();

  if (/\.(?:tif|eps|png|gif|jpeg|jpg|dwg|ai|cdr|bmp|webp)$/.test(fileName)) {
    fileType = 'jpg';
  } else if (/\.(?:doc|docx)$/.test(fileName)) {
    fileType = 'doc';
  } else if (/\.(?:pdf)$/.test(fileName)) {
    fileType = 'pdf';
  } else if (/\.(?:rar)$/.test(fileName)) {
    fileType = 'rar';
  } else if (/\.(?:xls|xlsx|csv)$/.test(fileName)) {
    fileType = 'xls';
  } else if (/\.(?:zip)$/.test(fileName)) {
    fileType = 'zip';
  } else if (/\.(?:7z)$/.test(fileName)) {
    fileType = 'zip';
  } else if (/\.(?:ppt|pptx)$/.test(fileName)) {
    fileType = 'ppt';
  } else if (/\.(?:txt)$/.test(fileName)) {
    fileType = 'txt';
  } else if (/\.(?:rm|rmvb|swf|avi|mov|wmv|mp4|mpg|mpeg|flv)$/.test(fileName)) {
    fileType = 'mov';
  } else if (/\.(?:wav|mp3|acm|aif|aifc|aiff|au|amr)$/.test(fileName)) {
    fileType = 'mp3';
  }
  if (fullTest) {
    if (/\.(?:png)$/.test(fileName)) {
      fileType = 'png';
    } else if (/\.(?:gif)$/.test(fileName)) {
      fileType = 'gif';
    }
  }
  // 文件上传 统计扩展名
  if (moreType) {
    if (/\.(?:bmp)$/.test(fileName)) {
      fileType = 'bmp';
    } else if (/\.(?:html)$/.test(fileName)) {
      fileType = 'html';
    } else if (/\.(?:exe)$/.test(fileName)) {
      fileType = 'exe';
    } else if (/\.(?:apk)$/.test(fileName)) {
      fileType = 'apk';
    } else if (/\.(?:dmg)$/.test(fileName)) {
      fileType = 'dmg';
    } else if (/\.(?:app)$/.test(fileName)) {
      fileType = 'app';
    } else if (/\.(?:msi)$/.test(fileName)) {
      fileType = 'msi';
    } else if (/\.(?:psd)$/.test(fileName)) {
      fileType = 'psd';
    } else if (/\.(?:docx)$/.test(fileName)) {
      fileType = 'docx';
    } else if (/\.(?:xlsx)$/.test(fileName)) {
      fileType = 'xlsx';
    } else if (/\.(?:pptx)$/.test(fileName)) {
      fileType = 'pptx';
    } else if (/\.(?:mp3)$/.test(fileName)) {
      fileType = 'mp3';
    } else if (/\.(?:mp4)$/.test(fileName)) {
      fileType = 'mp4';
    }
  }
  return fileType;
};

export const formatTime = (timestamp, formatType, def) => {
  formatType = formatType || 'YYYY-MM-DD HH:mm';
  if (timestamp === CONST.NUM_TIME_MIN) {
    return CONST.TEXT_HIDE;
  }
  if (!timestamp || timestamp === CONST.NUM_TIME_DEFAULT || timestamp === CONST.NUM_TIME_DEFAULT2) {
    return def || CONST.TEXT_DEFAULT;
  }
  return moment(timestamp).format(formatType);
};
// 随机打乱数组
export const shuffle = (aArr, toUpperCase) => {
  var iLength = aArr.length,
    i = iLength,
    mTemp,
    iRandom;
  while (i--) {
    if (i !== (iRandom = Math.floor(Math.random() * iLength))) {
      mTemp = aArr[i];
      if (toUpperCase) {
        mTemp = Math.random() > 0.5 ? (mTemp + '').toUpperCase() : mTemp;
      }
      aArr[i] = aArr[iRandom];
      aArr[iRandom] = mTemp;
    }
  }
  return aArr;
};
// 获取指定长度的随机数
export const getUUId = (len) => {
  len = Math.min(len || 9, 9);
  let time = new Date().getTime();
  let str = (Math.random().toString().substr(2) - 0 + time).toString(36);
  str = shuffle(str.split(''), true).join('');
  return str.substr(0, len);
};